import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../ServicePage.css';

function Kubernetes() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const k8sServices = [
        "Setup e configurazione cluster Kubernetes",
        "Migrazione da Docker Swarm a K8s",
        "Deployment strategies avanzate",
        "Service mesh con Istio/Linkerd",
        "Ingress controller e load balancing",
        "Persistent volumes e storage classes",
        "Secrets e ConfigMap management",
        "RBAC e security policies"
    ];

    const scalingFeatures = [
        "Horizontal Pod Autoscaler (HPA)",
        "Vertical Pod Autoscaler (VPA)",
        "Cluster Autoscaler",
        "Custom Resource Definitions",
        "Operators pattern implementation",
        "Multi-cluster federation",
        "Cross-zone load balancing",
        "Resource quotas e limits"
    ];

    const monitoringTools = [
        "Prometheus + Grafana stack",
        "Kubernetes Dashboard",
        "ELK Stack per logging",
        "Jaeger per distributed tracing",
        "Alertmanager configurazione",
        "Custom metrics collection",
        "Performance monitoring",
        "Cluster health dashboards"
    ];

    const devopsIntegration = [
        "GitOps con ArgoCD/Flux",
        "CI/CD pipeline con Tekton",
        "Helm charts management",
        "Kustomize per configurazioni",
        "Multi-environment deployments",
        "Canary deployments",
        "Blue-Green strategies",
        "Automated rollbacks"
    ];

    return (
        <div className="service-page">
            <Container>
                <div className="service-header">
                    <h1 className="service-title gradient-text">Kubernetes Orchestration</h1>
                    <p className="service-description">
                        Gestione completa di cluster Kubernetes per orchestrazione container,
                        scaling automatico e alta disponibilità delle tue applicazioni.
                    </p>
                </div>

                <Row className="mb-5">
                        <Col lg={8}>
                            <div className="service-description">
                                <h3>Orchestrazione Kubernetes Professionale</h3>
                                <p>
                                    Progetto e gestisco cluster Kubernetes per garantire scalabilità automatica,
                                    alta disponibilità e deployment zero-downtime delle tue applicazioni
                                    containerizzate in ambienti cloud-native.
                                </p>
                                <p>
                                    Dalla configurazione iniziale del cluster alla implementazione di
                                    strategie DevOps avanzate, offro soluzioni Kubernetes complete
                                    per ambienti enterprise e startup in crescita.
                                </p>
                            </div>

                            <div className="k8s-services">
                                <h3>Servizi Kubernetes</h3>
                                <Row>
                                    {k8sServices.map((service, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">⚙️</span>
                                                {service}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="scaling-section">
                                <h3>Scaling e Automazione</h3>
                                <Row>
                                    {scalingFeatures.map((feature, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">📈</span>
                                                {feature}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <Alert variant="success" className="k8s-alert">
                                <h5><i className="fas fa-rocket"></i> Cloud Native Architecture</h5>
                                <p>
                                    Implementazione di architetture cloud-native con microservizi,
                                    service mesh e pattern di resilienza per applicazioni scalabili
                                    e fault-tolerant.
                                </p>
                            </Alert>

                            <div className="monitoring-section">
                                <h3>Monitoring e Observability</h3>
                                <Row>
                                    {monitoringTools.map((tool, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">📊</span>
                                                {tool}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="devops-section">
                                <h3>DevOps e CI/CD Integration</h3>
                                <Row>
                                    {devopsIntegration.map((integration, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">🚀</span>
                                                {integration}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="service-process">
                                <h3>Metodologia Implementazione</h3>
                                <div className="process-steps">
                                    <div className="process-step-item">
                                        <div className="step-number">1</div>
                                        <div className="step-text">Assessment architettura e requirements</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">2</div>
                                        <div className="step-text">Design cluster e networking topology</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">3</div>
                                        <div className="step-text">Setup cluster e security policies</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">4</div>
                                        <div className="step-text">Migrazione applicazioni e monitoring</div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4}>
                            <div className="service-sidebar">
                                <Card className="service-info-card">
                                    <Card.Body>
                                        <h4>Piani Kubernetes</h4>
                                        <div className="pricing-plan">
                                            <h5>K8s Starter</h5>
                                            {/* <div className="plan-price">€350/mese</div> */}
                                            <ul>
                                                <li>Cluster singolo</li>
                                                <li>Basic monitoring</li>
                                                <li>Backup automatici</li>
                                                <li>Supporto 9-18</li>
                                                <li>Scaling manuale</li>
                                            </ul>
                                        </div>

                                        <div className="pricing-plan featured">
                                            <h5>K8s Professional</h5>
                                            {/* <div className="plan-price">€650/mese</div> */}
                                            <ul>
                                                <li>Multi-cluster setup</li>
                                                <li>Auto-scaling avanzato</li>
                                                <li>Service mesh</li>
                                                <li>GitOps deployment</li>
                                                <li>Monitoring 24/7</li>
                                                <li>Support prioritario</li>
                                            </ul>
                                        </div>

                                        <div className="pricing-plan">
                                            <h5>K8s Enterprise</h5>
                                            {/* <div className="plan-price">€1200/mese</div> */}
                                            <ul>
                                                <li>Multi-cloud federation</li>
                                                <li>Advanced security</li>
                                                <li>Custom operators</li>
                                                <li>Disaster recovery</li>
                                                <li>Dedicated support</li>
                                                <li>SLA 99.99%</li>
                                            </ul>
                                        </div>
                                    </Card.Body>
                                </Card>

                                <Card className="k8s-features-card">
                                    <Card.Body>
                                        <h4>🚀 Ecosistema K8s</h4>
                                        <ul>
                                            <li>Helm package manager</li>
                                            <li>Istio service mesh</li>
                                            <li>ArgoCD GitOps</li>
                                            <li>Prometheus monitoring</li>
                                            <li>Cert-manager TLS</li>
                                            <li>Velero backup</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <Card className="cloud-providers-card">
                                    <Card.Body className="text-center">
                                        <h5>☁️ Cloud Providers</h5>
                                        <p>Supporto completo per:</p>
                                        <ul style={{textAlign: 'left'}}>
                                            <li>AWS EKS</li>
                                            <li>Google GKE</li>
                                            <li>Azure AKS</li>
                                            <li>DigitalOcean DOKS</li>
                                            <li>On-premise clusters</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <div className="cta-section">
                                    <a href="#contact" className="btn-gradient w-100 mb-3">
                                        <span>Richiedi Preventivo K8s</span>
                                    </a>
                                    <Link to="/services" className="btn btn-outline-primary w-100">
                                        Torna ai Servizi
                                    </Link>
                                </div>
                            </div>
                        </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Kubernetes;